import { useChannel } from './useChannelHooks';

export const useReadPosition = (
  channelGuid: string,
  userGuid: string,
): string | null => {
  const channel = useChannel(channelGuid);
  return channel?.readPositions?.[userGuid]?.guid ?? null;
};
